import React from 'react';

import styles from "../style/prediction.module.scss";
import {Image} from "../../image/image";
import classNames from "classnames";
import {PROPOSITION_BETS} from "../../../../widgets/proposition-bets-widget/proposition-bets-widgets.consts";

export const PredictionTitle = ({prediction, controller}) => {
  const {state} = controller;
  const {currentContext} = state;
  const {title, athleteId, gameId} = prediction;

  const iconProps = {
    className: classNames(styles.icon),
    src: currentContext?.iconSource,
    onClick: () => controller.action(PROPOSITION_BETS.ACTION_TYPES.onPopupClick, {athleteId, lineTypeId: prediction?.type, gameId})
  }

  return (
    <div className={styles.title}>
      {title}
      {
        prediction?.hasRecords ? <Image {...iconProps}/> : null
      }
    </div>
  )
};
